import { createReducer } from '@reduxjs/toolkit';
import { suggestionActions } from '../elevio.actions/suggestions';
export const initialSuggestionState = {
    token: null,
    companyUid: '',
    authState: 'uninitialized',
    subscriptionStatus: 'Initialising',
    conversationStore: {},
    fetching: false,
    userId: null,
    userEmail: null,
    errorMessage: null,
    languages: {
        availableLanguages: {
            results: undefined,
            loading: false,
            error: undefined,
        },
        detectedLanguages: {},
        defaultLanguage: {
            id: '',
            nativeName: 'Loading...',
        },
    },
};
export const suggestionReducer = createReducer(initialSuggestionState, (builder) => builder
    .addCase(suggestionActions.setInitialConversationSuggestionState, (state, action) => {
    state.conversationStore[action.payload.conversationId] = {
        articleIds: [],
        suggestions: [],
        unableToFindTaggedSuggestions: false,
    };
    state.errorMessage = null;
})
    .addCase(suggestionActions.fetchAvailableLanguagesRequest, (state) => {
    state.languages.availableLanguages.loading = true;
})
    .addCase(suggestionActions.fetchAvailableLanguagesComplete, (state, action) => {
    const defaultLanguage = action.payload.languages.find((lang) => lang.id === action.payload.defaultLanguageId);
    if (defaultLanguage) {
        state.languages.defaultLanguage = defaultLanguage;
    }
    if (!state.languages.availableLanguages.results) {
        state.languages.availableLanguages = {
            loading: false,
            results: action.payload.languages,
            error: undefined,
        };
    }
})
    .addCase(suggestionActions.fetchAvailableLanguagesFailure, (state) => {
    state.languages.availableLanguages = {
        error: new Error('Unable to fetch available languages'),
        loading: false,
        results: state.languages.availableLanguages.results,
    };
})
    .addCase(suggestionActions.setDetectedLanguageId, (state, action) => {
    state.languages.detectedLanguages[action.payload.conversationId] =
        action.payload.languageId;
})
    .addCase(suggestionActions.viewArticle, (state, action) => {
    const { articleId, ticketId } = action.payload;
    const conversationId = Number(ticketId);
    if (state.conversationStore[conversationId]) {
        state.conversationStore[conversationId].articleIds.push(articleId);
    }
})
    .addCase(suggestionActions.articleNavBack, (state, action) => {
    var _a, _b;
    const { conversationId } = action.payload;
    if (!((_b = (_a = state.conversationStore[conversationId]) === null || _a === void 0 ? void 0 : _a.articleIds) === null || _b === void 0 ? void 0 : _b.length)) {
        return;
    }
    state.conversationStore[conversationId].articleIds =
        state.conversationStore[conversationId].articleIds.slice(0, -1);
})
    .addCase(suggestionActions.clearTokenAndCompanyUid, (state) => {
    state.token = null;
    state.companyUid = '';
    state.authState = 'uninitialized';
    state.conversationStore = {};
    state.errorMessage = null;
})
    .addCase(suggestionActions.fetchTokenStart, (state) => {
    state.authState = 'pending';
})
    .addCase(suggestionActions.fetchTokenSuccess, (state, action) => {
    state.authState = 'fulfilled';
    state.token = action.payload.token;
    state.companyUid = action.payload.companyUid;
    state.userId = action.payload.userId;
    state.userEmail = action.payload.userEmail;
    state.errorMessage = null;
})
    .addCase(suggestionActions.fetchTokenError, (state) => {
    state.authState = 'rejected';
    state.errorMessage = 'Failed to fetch token';
})
    .addCase(suggestionActions.subscriptionStatusSuccess, (state) => {
    state.subscriptionStatus = 'Active';
})
    .addCase(suggestionActions.subscriptionStatusError, (state, action) => {
    state.subscriptionStatus = 'Inactive';
    if (action.payload.errorMessage) {
        state.errorMessage = action.payload.errorMessage;
    }
})
    .addCase(suggestionActions.fetchSuggestionsRequest, (state) => {
    state.fetching = true;
})
    .addCase(suggestionActions.fetchSuggestionsComplete, (state, action) => {
    state.fetching = false;
    state.errorMessage = null;
    if (state.conversationStore[action.payload.conversationId]) {
        state.conversationStore[action.payload.conversationId].suggestions =
            action.payload.results;
    }
})
    .addCase(suggestionActions.fetchSuggestionsFailure, (state, action) => {
    state.fetching = false;
    state.errorMessage = action.payload.errorMessage;
})
    .addCase(suggestionActions.setUnableToFindTaggedSuggestions, (state, action) => {
    const { conversationId } = action.payload;
    if (!state.conversationStore[conversationId]) {
        state.conversationStore[conversationId] = {
            articleIds: [],
            suggestions: [],
            unableToFindTaggedSuggestions: false,
        };
    }
    state.conversationStore[conversationId].unableToFindTaggedSuggestions =
        action.payload.unableToFindTaggedSuggestions;
}));
